import LayoutConfigTypes from "@/core/config/LayoutConfigTypes";
import { number } from "yup/lib/locale";

const config: LayoutConfigTypes = {
  themeName: "Metronic",
  themeVersion: "8.0.25",
  demo: "demo1",
  main: {
    type: "default",
    primaryColor: "#009EF7",
    logo: {
      dark: "media/logos/logo-1-dark.svg",
      light: "media/logos/logo-1.svg",
    },
  },
  loader: {
    logo: "media/logos/logo-1-dark.svg",
    display: true,
    type: "default",
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: "font",
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: true,
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
    filterDate: new Date(),
  },
  aside: {
    display: true,
    theme: "dark",
    fixed: true,
    menuIcon: "svg",
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: "fixed",
    darkMode: false,
  },
  footer: {
    width: "fluid",
  },
  flexibleProcurement: {
    current: 0,
    reportName: 2,
    scenarioName: 1,
  },
};

export default config;
